if (!customElements.get('isso-korea-journal')) {
  customElements.define(
    'isso-korea-journal',
    class IssoKoreaJournal extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.cards = Array.from(this.querySelectorAll('[data-ik-journal-card]'));
        this.panels = Array.from(this.querySelectorAll('[data-ik-journal-panel]'));
        if (!this.cards.length || !this.panels.length) return;

        this.dataset.ready = 'true';
        const storyPanel = this.panels.find((panel) => panel.textContent.toUpperCase().includes('ISSO STORY'));
        if (storyPanel) {
          const storyImageUrl = 'https://cdn.shopify.com/s/files/1/0926/9831/2994/files/Banff_______16x9_7e8e202a-c99c-47ab-ad43-726449bbf4b3.png?v=1790133341';
          const storyIndex = this.panels.indexOf(storyPanel);
          storyPanel.querySelectorAll('.ik-journal-reader__image').forEach((image) => {
            image.src = storyImageUrl;
          });
          if (storyIndex >= 0) {
            this.cards[storyIndex]?.querySelectorAll('.ik-journal-card__image').forEach((image) => {
              image.src = storyImageUrl;
            });
          }
          const titleMap = [
            ['간단히 소개', 'ISSO Brand 소개'],
            ['핵심 가치와 철학', 'ISSO의 핵심가치와 철학'],
            ['Black 라인과 White 라인', 'ISSO Black & White 라인'],
            ['제품 생산과 패키징', '제품 생산과 패키징의 기준'],
            ['고객들과는 어떻게 소통', '고객과의 소통'],
            ['앞으로의 비전과 계획', 'ISSO의 비전과 계획'],
            ['ISSO만의 강점', 'ISSO만의 강점'],
          ];
          storyPanel.querySelectorAll('.ik-journal-reader__body li').forEach((item) => {
            const normalized = item.textContent.replace(/\s+/g, ' ').trim();
            const match = titleMap.find(([key]) => normalized.includes(key));
            if (match) item.textContent = match[1];
          });
        }
        this.cards.forEach((card) => {
          card.addEventListener('click', (event) => {
            if (
              event.defaultPrevented ||
              event.button !== 0 ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey
            ) {
              return;
            }

            const panelId = card.getAttribute('aria-controls');
            const panel = panelId
              ? this.panels.find((candidate) => candidate.id === panelId)
              : null;
            if (!panel) return;

            event.preventDefault();
            this.cards.forEach((candidate) => {
              candidate.setAttribute('aria-current', candidate === card ? 'true' : 'false');
            });
            this.panels.forEach((candidate) => {
              candidate.hidden = candidate !== panel;
            });
          });
        });
      }
    }
  );
}


(() => {
  const initMobileJournal = () => {
    if (!window.matchMedia('(max-width: 639px)').matches) return;
    document.querySelectorAll('[data-ik-journal]').forEach((journal) => {
      if (journal.dataset.mobileJournalReady === 'true') return;
      journal.dataset.mobileJournalReady = 'true';
      const cards = [...journal.querySelectorAll('[data-ik-journal-card]')];
      const panels = [...journal.querySelectorAll('[data-ik-journal-panel]')];
      const reader = journal.querySelector('[data-ik-journal-reader]');
      cards.forEach((card) => card.setAttribute('aria-current', 'false'));
      panels.forEach((panel) => { panel.hidden = true; });
      cards.forEach((card) => {
        card.addEventListener('click', () => {
          window.requestAnimationFrame(() => reader?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileJournal, { once: true });
  } else {
    initMobileJournal();
  }
})();